import { template as template_485facbebd354351918b5d32f66a0e42 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/html';
export default RouteTemplate(template_485facbebd354351918b5d32f66a0e42(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
